import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import React from "react";
import Loader from 'react-loader-spinner'

export default class Spinner extends React.Component {
    //other logic
      render() {
       return(
           <div style={{left:"50%",top:"50%",paddingLeft:"50%"}}>
               <Loader type="RevolvingDot" color="crimson" height={100} width={100}/>
           </div>
        
       );
      }
   }